module.exports = {"430111001":"侯家塘街道","430111002":"左家塘街道","430111003":"圭塘街道","430111004":"砂子塘街道","430111005":"东塘街道","430111006":"雨花亭街道","430111007":"高桥街道","430111008":"洞井街道","430111009":"黎托街道","430111010":"井湾子街道","430111011":"同升街道","430111012":"东山街道","430111101":"跳马镇","430111400":"长沙雨花经济开发区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430111.json
// module id = 1808
// module chunks = 0